<template>
  <el-dialog
    :title="
      bid && bid.load_date
        ? 'Редактирование дня погрузки'
        : 'Добавление дня погрузки'
    "
    :visible="visible"
    width="50%"
    custom-class="day-add-modal"
    @open="beforeOpen"
    @close="beforeClose"
  >
    <el-alert
      v-if="alert_day"
      title="Данный день занят!"
      type="error"
      center
      show-icon
    />
    <el-form
      ref="form"
      v-loading="isLoading"
      :model="loadDayData"
      :rules="dayAddRules"
      @submit.native.prevent
    >
      <el-row :gutter="40">
        <el-col :span="12">
          <el-form-item prop="cars_count">
            <p>Количество авто</p>
            <el-input-number
              v-model="loadDayData.cars_count"
              :controls="false"
              :min="0"
              placeholder="Введите количество авто"
            />
          </el-form-item>
        </el-col>
        <el-col v-if="canAction('shipping_bids_edit')" :span="12">
          <el-form-item prop="load_date">
            <p>Дата начала погрузки</p>
            <el-date-picker
              id="start_loading"
              v-model="loadDayData.load_date"
              type="date"
              placeholder="Выберите дату погрузки"
              :picker-options="getOptions()"
              value-format="yyyy-MM-dd"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="canAction('shipping_bids_edit')" :gutter="40">
        <template v-if="bid.type_code !== 'harvest'">
          <el-col :span="12">
            <el-form-item prop="price_from_storage_bidder">
              <p>Цена перевозки, руб/кг</p>
              <el-input-number
                v-model="loadDayData.price_from_storage_bidder"
                :controls="false"
                :min="0"
                :step="0.02"
                :max="500000"
                :precision="3"
                placeholder="Укажите цену перевозки"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              v-if="isAdminOrCeoRole"
              prop="price_from_storage_driver"
            >
              <p>Цена перевозки для водителя, руб/кг</p>
              <el-input-number
                v-model="loadDayData.price_from_storage_driver"
                :controls="false"
                :min="0"
                :step="0.02"
                :max="500000"
                :precision="3"
                placeholder="Укажите цену перевозки для водителя"
              />
            </el-form-item>
          </el-col>
        </template>
        <template v-if="bid.type_code !== 'delivery'">
          <el-col :span="12">
            <el-form-item prop="price_from_field_bidder">
              <p>Цена уборки, руб/кг</p>
              <el-input-number
                v-model="loadDayData.price_from_field_bidder"
                :controls="false"
                :min="0"
                :step="0.02"
                :max="500000"
                :precision="3"
                placeholder="Укажите цену уборки"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              v-if="isAdminOrCeoRole"
              prop="price_from_field_driver"
            >
              <p>Цена уборки для водителя, руб/кг</p>
              <el-input-number
                v-model="loadDayData.price_from_field_driver"
                :controls="false"
                :min="0"
                :step="0.02"
                :max="500000"
                :precision="3"
                placeholder="Укажите цену уборки для водителя"
              />
            </el-form-item>
          </el-col>
        </template>
      </el-row>
      <el-row v-if="isAdminOrCeoRole">
        <el-checkbox
          v-model="loadDayData.update_responses_prices"
          :true-label="1"
          :false-label="0"
        >
          Менять цену существующим откликам?
        </el-checkbox>
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button
        v-if="bid.load_date"
        :disabled="isLoading"
        :loading="isLoading"
        type="danger"
        @click="deleteLoadDay"
      >
        Удалить
      </el-button>
      <el-button
        type="primary"
        :disabled="isLoading"
        :loading="isLoading"
        @click="reservedLoadDay"
      >
        {{ bid.load_date ? 'Сохранить' : 'Добавить' }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { dayAddRules } from '@/views/Home/Shipping/Item/constants'
import { mapActions, mapGetters } from 'vuex'
import { pickerOpt, pickerOptions } from '@/datas/consts'

export default {
  name: 'ShippingDayAdd',
  props: {
    bid: {
      type: Object,
      default: () => {},
    },
    onClose: {
      type: Function,
      default: () => {},
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      alert_day: false,
      loadDayData: {
        load_date: undefined,
        cars_count: undefined,
        price_from_storage_bidder: undefined,
        price_from_storage_driver: undefined,
        price_from_field_bidder: undefined,
        price_from_field_driver: undefined,
        update_responses_prices: 0,
      },
      pickerOptions,
      pickerOpt,
      dayAddRules,
    }
  },
  computed: {
    ...mapGetters('bids', ['getLoading']),
    isLoading() {
      return this.getLoading('Modal')
    },
  },
  methods: {
    ...mapActions('bids', [
      'createBidsDay',
      'updateDayFields',
      'deleteBidsDay',
    ]),
    beforeOpen() {
      let obj = this.bid
      const { cars_count, load_days, load_date } = obj

      this.loadDayData.cars_count = cars_count
      this.loadDayData.load_date = load_date

      if (!load_date) {
        obj = load_days?.length ? load_days[load_days.length - 1] : {}
      }

      for (let key in this.loadDayData) {
        if (
          !Object.prototype.hasOwnProperty.call(this.loadDayData, key) ||
          !key.includes('price_from')
        ) {
          continue
        }
        this.loadDayData[key] = obj[key]
      }
    },
    getOptions() {
      return this.isAdminOrCeoRole ? pickerOpt : pickerOptions
    },
    reservedLoadDay() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          if (this.bid.load_date) {
            this.updateLoadDay()
          } else {
            this.createLoadDay()
          }
        }
      })
    },
    createLoadDay() {
      this.createBidsDay({
        bid_id: this.bid.id,
        user_type: this.userInfo.user_type,
        data: this.loadDayData,
        callback: isSuccess => {
          if (isSuccess) {
            this.beforeClose()
            this.$message.success('День успешно создан')
          }
          this.alert_day = !isSuccess
        },
      })
    },
    updateLoadDay() {
      this.updateDayFields({
        id: this.bid.id,
        data: this.loadDayData,
        callback: isSuccess => {
          if (isSuccess) {
            this.beforeClose()
            this.$message.success('День успешно обновлен')
          }
          this.alert_day = !isSuccess
        },
      })
    },
    deleteLoadDay() {
      const { id, bid_id } = this.bid

      if (id) {
        this.deleteBidsDay({
          id,
          bid_id,
          callback: () => {
            this.beforeClose()
            this.$message.success('День успешно удален')
          },
        })
      }
    },
    beforeClose() {
      this.$emit('close')
    },
  },
}
</script>

<style lang="sass">
.day-add-modal
  .el-form-item__content
    line-height: 1
  .el-input-number, .el-date-editor.el-input, .el-date-editor.el-input__inner
    width: 100%
</style>
